/**
 * Template: Index
 * -----------------------------------------------------------------------------
 * Scripts to execute on the index page.
 *
 */

import {load} from '@shopify/theme-sections';



 /*
  import '~/sections/image-slider'; 
  import '~/sections/full-bleed-image-vdeo';
  import '~/sections/image-video-hero'; 
  import '~/sections/boxes-featured-collections';
*/


document.addEventListener('DOMContentLoaded', () => {
  load('*');

  if (!localStorage.getItem('registerForm')) {
    return;
  }

  localStorage.removeItem('registerForm');

  window.dataLayer.push({
    event: 'GAevent',
    eventID: '09',
    eventCategory: 'account',
    eventAction: 'registration',
    eventLabel: 'step2',
  });
});
